<template>
  <div>
    <div class="posiCent">
      <img
        src="~@ota-frontend/shared-assets/images/ic_plane.svg"
        class="loadingModal-plane"
        :style="{ left: alignFlightIcon + 'px' }"
      />
      <div class="loadingModal-circularWrapper">
        <div class="loadingModal-code">{{ departure }}</div>
        <tk-circular-progress
          v-for="item in numberOfSpinner"
          :key="item"
          :turning="item === indexOfTurning"
        ></tk-circular-progress>
        <div class="loadingModal-code">{{ destination }}</div>
      </div>
    </div>
    <p class="loadingModal-text" :style="styleMessage">{{ message }}</p>
    <div class="loadingModal-bar">
      <span
        class="loadingModal-loadedBar"
        :style="{ width: progress + '%' }"
      ></span>
    </div>
  </div>
</template>

<script>
import TkCircularProgress from '../../atoms/TkCircularProgress/TkCircularProgress.vue'
const MAX_WIDTH_PROGRESS_BAR = 100
const MIN_WIDTH_PROGRESS_BAR = 0
const NUMBER_OF_SPINNER = 4
const DISTANCE_OF_FLIGHT = 140
const defaultStyleMessage = {
  bottom: '200px',
}
export default {
  name: 'TkFlightLoadingProgressbar',
  components: {
    TkCircularProgress,
  },
  props: {
    departure: {
      type: String,
      default: '',
    },
    destination: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      progress: MIN_WIDTH_PROGRESS_BAR,
      numberOfSpinner: [...Array(NUMBER_OF_SPINNER).keys()],
      styleMessage: null,
    }
  },
  computed: {
    alignFlightIcon() {
      return (
        (DISTANCE_OF_FLIGHT * this.progress) / MAX_WIDTH_PROGRESS_BAR -
        DISTANCE_OF_FLIGHT / 2
      )
    },
    indexOfTurning() {
      const idx = Math.floor(
        (NUMBER_OF_SPINNER * this.progress) / MAX_WIDTH_PROGRESS_BAR
      )
      return idx < NUMBER_OF_SPINNER ? idx : NUMBER_OF_SPINNER - 1
    },
  },
  created() {
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('android') > -1) {
      this.styleMessage = defaultStyleMessage
    }
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.progress < MAX_WIDTH_PROGRESS_BAR) {
        this.progress += Math.floor(Math.random() * 3)
      } else {
        clearInterval(timer)
      }
    }, 100)

    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
    })
  },
}
</script>

<style>
.loadingModal {
  pointer-events: none;
}
.loadingModal .modal-content {
  overflow: hidden;
  height: 400px;
  position: relative;
  background-color: rgba(255, 255, 255, 0.96);
}
.loadingModal-circularWrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 70px;
}
.loadingModal-code {
  font-size: 20px;
  margin: 0 18px;
  color: #f9423a;
  font-weight: bold;
  letter-spacing: 0.2px;
}
.loadingModal-circular + .loadingModal-circular {
  margin-left: 7.2px;
}
.loadingModal-circular {
  position: relative;
  height: 28px;
  width: 28px;
  border: 4px solid rgba(249, 66, 58, 0.2);
  border-radius: 50%;
}
.loadingModal-circular:after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  border: 4px solid transparent;
  top: -4px;
  right: -4px;
  border-top-color: #f9423a;
  z-index: 1;
  opacity: 0;
  animation-timing-function: ease-in-out;
  -webkit-animation-timing-function: ease-in-out;
  animation-duration: 1s;
  -webkit-animation-duration: 1s;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.loadingModal-circular.is-turning:after {
  opacity: 1;
  animation-name: turning_acw;
  -webkit-animation-name: turning_acw;
}
.loadingModal-plane {
  display: block;
  margin: 0 auto 20px;
  width: 32px;
  left: -70px;
  position: relative;
  transition: left 1s ease-out;
}
.loadingModal-bar {
  position: absolute;
  bottom: 0;
  background: #dedfdf;
  overflow: hidden;
  width: 100%;
}
.loadingModal-bar,
.loadingModal-loadedBar {
  height: 8px;
}
.loadingModal-loadedBar {
  position: absolute;
  left: 0;
  transform: scale(1.05);
  transition: width 1s linear;
  background: #f9423a;
  border-radius: 15px;
  width: 0;
}
.loadingModal-text {
  font-size: 17px;
  color: #707070;
  font-weight: bold;
  text-align: center;
  bottom: 37px;
  left: 0;
  width: 100%;
  position: absolute;
}
@-webkit-keyframes turning_acw {
  0% {
    opacity: 0;
    transform: rotate(0deg);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(360deg);
  }
}

@keyframes turning_acw {
  0% {
    opacity: 0;
    transform: rotate(0deg);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 657px) {
  .loadingModal > .posiCent {
    top: 0;
    left: 0;
    transform: none;
    -webkit-transform: none;
    height: 100%;
  }

  .loadingModal .modal-dialog {
    width: 100%;
    height: 100vh;
    margin: 0;
  }
  .loadingModal .modal-content {
    height: 100vh;
    border-radius: 0;
    border: 0;
  }
}
</style>
